import { render, staticRenderFns } from "./ConferenciaListReprovados.vue?vue&type=template&id=4bea4b2e"
import script from "./ConferenciaListReprovados.vue?vue&type=script&lang=js"
export * from "./ConferenciaListReprovados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports